import React from 'react'
import './KovalentHero.scss' 

export class KovalentHero extends React.Component {
  render() {
    return (
      <div
        className="cloudsecops-page-hero"
        style={{ backgroundImage: 'url(/cloudsecopsbg.jpg)' }}
      >
        <div className="overlay" />
        <div className="inner-wrap">
          <div className="text">
            <h1>Enclave AI: The Data Platform for Disconnected Environments</h1>
            <h2>A modern data platform built on Apache Iceberg - enabling AI and LLMs in air-gapped and controlled environments.</h2>
          </div>
        </div>
      </div>
    )
  }
}

export default KovalentHero
